export default {
  API_DEV: "http://api.dev.u-money.mn",
  API_TEST: "http://api.test.u-money.mn",
  API_PROD: "https://api.u-money.mn",

  ROOT_DEV: "http://dev.u-money.mn",
  ROOT_TEST: "http://test.u-money.mn",
  ROOT_PROD: "https://u-money.mn"
};
